import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import SubnavigationTemplate from './SubnavigationTemplate';

import navigationTabs from '../../content/navigation.json';

const MOBILE_WIDTH = 580;

class Subnavigation extends PureComponent {
  getActiveTabIndex = (pathname) => {
    return this.props.navigationTabs.findIndex(tab => {
      return (pathname.startsWith(tab.pathname))  ||
        (tab.links.findIndex(link => pathname.startsWith(link.pathname)) !== -1);
    });
  };

  render() {
    const activeIndex = this.getActiveTabIndex(this.props.location.pathname);

    return (
      <SubnavigationTemplate
        activeIndex={activeIndex}
        navigationTabs={this.props.navigationTabs}
        isMobile={this.props.isMobile}
      />
    );
  }
}

Subnavigation.propTypes = {
  navigationTabs: PropTypes.arrayOf(PropTypes.object),
  isMobile: PropTypes.bool
};

const mapStateToProps = (state) => ({
  navigationTabs,
  isMobile: state.app.width < MOBILE_WIDTH
});


const main = [
  'we',
  'manage',
  'analyze',
  'promotion',
  'support',
  'success-stories'
];

const createRoute = (pathname) => ({
  path: `/${pathname}/subnavigation/`,
  component: connect(mapStateToProps)(Subnavigation)
});

export default main.map(createRoute);



// WEBPACK FOOTER //
// ./src/components/Subnavigation/index.js